<template>
  <div class="ma-4 app">
    <div class="text-h4 mb-2">Agendamento de Tarefas</div>
    <v-tabs v-model="tabs" background-color="background">
      <v-tab v-for="n in tipos" :key="n">
        {{ tipo[n - 1] }}
      </v-tab>
    </v-tabs>
    <v-tabs-items v-model="tabs">
      <v-tab-item>
        <AbaAgendamentoData />
      </v-tab-item>
      <v-tab-item>
        <AbaAgendamentoAno />
      </v-tab-item>
      <v-tab-item>
        <AbaAgendamentoMes />
      </v-tab-item>
      <v-tab-item>
        <AbaAgendamentoSemana />
      </v-tab-item>
      <v-tab-item>
        <AbaAgendamentoHora />
      </v-tab-item>
    </v-tabs-items>
  </div>
</template>

<script>
import AbaAgendamentoData from '../_components/AbaAgendamentoData'
import AbaAgendamentoMes from '../_components/AbaAgendamentoMes'
import AbaAgendamentoSemana from '../_components/AbaAgendamentoSemana'
import AbaAgendamentoHora from '../_components/AbaAgendamentoHora'
import AbaAgendamentoAno from '../_components/AbaAgendamentoAno'

export default {
  name: 'CadastroAgendamento',
  components: { AbaAgendamentoData, AbaAgendamentoMes, AbaAgendamentoSemana, AbaAgendamentoHora, AbaAgendamentoAno },
  data: () => ({
    tipos: 5,
    tab: null,
    tabs: 5,
    tipo: ['Data', 'Ano', 'Mês', 'Dia', 'Hora'],
  }),
}
</script>

<style scoped>
.app {
  background-color: var(--v-background-base);
}
</style>
